module.exports = __webpack_public_path__ + "static/media/app_icon.3090897d.svg";